module.exports = __webpack_public_path__ + "img/date.b64fd0cf.svg";